<template>
  <div class="outer-results-print">
    <div class="inner-results-print">
      <div class="font-13 bold text-color mrg-t-6 mrg-b-12">
        {{ $store.state.progressWindow.bottomMessage }}
      </div>
      <span class="text-title">{{
        $store.state.progressWindow.topMessage
      }}</span>

      <freeSearchProgress
        :show="!$store.state.progressWindow.hideProg"
        :percent="$store.state.progressWindow.percent"
        :search="progressTxt"
        :seconds="false"
        @stop="stop()"
        message=""
      />
    </div>
  </div>
</template>
<script>
import freeSearchProgress from "@/components/listBookArea/freeSearchBarContainer/freeSearchProgress.vue";

export default {
  components: {
    freeSearchProgress,
  },
  data() {
    return {};
  },
  computed: {
    progressTxt() {
      return this.$store.state.progressWindow.progressMessage;
    },
  },
  methods: {
    stop() {
      this.message = this.$t("bookPrint.exportActionStop");
      this.$store.state.progressWindow.stopFunc();
    },
    close() {},
  },
};
</script>
<style lang="scss" scoped>
.inner-results-print {
  text-align: center;
  padding: 20px 0;
  height: 150px;
}
.text-title {
  color: var(--custom-color1);
  font-weight: 500;
  padding-bottom: 20px;
}
</style>
